/*global angular*/
var bibMultimediaSection = angular.module('bibMultimediaSection', ['chart.js']);
bibMultimediaSection.factory('RecursionHelper', ['$compile', function ($compile) {
  'use strict';
  return {
    /**
     * Manually compiles the element, fixing the recursion loop.
     * @param element
     * @param [link] A post-link function, or an object with function(s) registered via pre and post properties.
     * @returns An object containing the linking functions.
     */
    compile: function (element, link) {
      // Normalize the link parameter
      if(angular.isFunction(link)){
        link = { post: link };
      }

      // Break the recursion loop by removing the contents
      var contents = element.contents().remove();
      var compiledContents;
      return {
        pre: link && link.pre ? link.pre : null,
        /**
         * Compiles and re-adds the contents
         */
        post: function (scope, el){
          // Compile the contents
          if (!compiledContents) {
            compiledContents = $compile(contents);
          }
          // Re-add the compiled contents to the element
          compiledContents(scope, function (clone) {
            el.append(clone);
          });

          // Call the post-linking function, if any
          if (link && link.post) {
            link.post.apply(null, arguments);
          }
        }
      };
    }
  };
}]);

bibMultimediaSection.directive('bibMultimediaSection', ['$q', 'settings', 'RecursionHelper', function ($q, settings, RecursionHelper) {
  'use strict';
  return {
    restrict: 'E',
    template: require('./bibMultimediaSection.html'),
    replace: true,
    transclude: true,
    scope: {
      data: '='
    },
    link: function (scope) {
      var i;
      for (i = 0; i < scope.data.attachments.length; i++) {
        if (scope.data.attachments[i].type === 'CONTENT') {
          scope.htmlContent = settings.apisAndUrls.api + scope.data.attachments[i].href;
          break;
        }
      }
    },
    compile: function (element) {
      return RecursionHelper.compile(element);
    }
  };
}]);
module.exports = bibMultimediaSection;



// WEBPACK FOOTER //
// ./web/js/module/bibMultimediaSection/bibiMultimediaSection.js